import { render, staticRenderFns } from "./CreateHomeWork.vue?vue&type=template&id=ea58f8b0&"
import script from "./CreateHomeWork.vue?vue&type=script&lang=js&"
export * from "./CreateHomeWork.vue?vue&type=script&lang=js&"
import style0 from "./CreateHomeWork.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports